import React from "reactn";
import AttendanceCalendarTable from "./AttendanceCalendarTable/AttendanceCalendarTable";
import { format, addDays, subDays, startOfWeek, endOfWeek } from "date-fns";
import axios from "axios";
import { DataArrowLeft, DataArrowRight } from "../../../assets";

class Attendance extends React.PureComponent {
  constructor() {
    super();
    const today = new Date();
    this.state = {
      start: startOfWeek(today),
      end: endOfWeek(today),
      students: [],
      attendance: {},
      programId: null
    };
    this.changeDatePeriod = this.changeDatePeriod.bind(this);
    this.setChildStatus = this.setChildStatus.bind(this);
  }

  getNumericDay(day) {
    const days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ];
    return days.indexOf(day);
  }

  async componentDidMount() {
    const type = this.props.location.search.split("?")[1];

    if (type === "Program") {
      const ep = `${process.env.REACT_APP_API}/partner/attendance/simple/${
        this.props.match.params.id
      }/${format(this.state.start, "yyyy-MM-dd")}/${format(
        this.state.end,
        "yyyy-MM-dd"
      )}`;

      const ep2 = `${process.env.REACT_APP_API}/partners/programs/${this.props.match.params.id}`;

      try {
        this.setState({
          programId: this.props.match.params.id
        });
      } catch (stateError) {
        console.error('Error setting programId:', stateError);
      }

      try {
        try {
          this.setGlobal({ loading: true });
        } catch (globalError) {
          console.error('Error setting loading state on mount:', globalError);
        }
        
        const res = await axios.get(ep);
        const res2 = await axios.get(ep2);

        try {
          this.setState({
            students: res.data.data.students,
            attendance: res.data.data.attendance,
            program: res2.data.data
          });
        } catch (stateError) {
          console.error('Error setting component state on mount:', stateError);
        }
        
        try {
          this.setGlobal({ loading: false, lastAPICall: res });
        } catch (globalError) {
          console.error('Error updating global state after mount:', globalError);
        }
      } catch (ex) {
        console.error(ex);
        try {
          this.setGlobal({ loading: false, lastAPICall: null });
        } catch (globalError) {
          console.error('Error setting global state in catch on mount:', globalError);
        }
      }
    }

    if (type === "Online") {
      const ep = `${process.env.REACT_APP_API}/partner/attendance/online/${
        this.props.match.params.id
      }/${format(this.state.start, "yyyy-MM-dd")}/${format(
        this.state.end,
        "yyyy-MM-dd"
      )}`;

      const ep2 = `${process.env.REACT_APP_API}/partners/virtual/${this.props.match.params.id}`;

      try {
        this.setState({
          programId: this.props.match.params.id
        });
      } catch (stateError) {
        console.error('Error setting programId for online:', stateError);
      }

      try {
        try {
          this.setGlobal({ loading: true });
        } catch (globalError) {
          console.error('Error setting loading state on mount for online:', globalError);
        }
        
        const res = await axios.get(ep);
        const res2 = await axios.get(ep2);

        try {
          this.setState({
            students: res.data.data.students,
            attendance: res.data.data.attendance,
            program: res2.data.data
          });
        } catch (stateError) {
          console.error('Error setting component state on mount for online:', stateError);
        }
        
        try {
          this.setGlobal({ loading: false, lastAPICall: res });
        } catch (globalError) {
          console.error('Error updating global state after mount for online:', globalError);
        }
      } catch (ex) {
        console.error(ex);
        try {
          this.setGlobal({ loading: false, lastAPICall: null });
        } catch (globalError) {
          console.error('Error setting global state in catch on mount for online:', globalError);
        }
      }
    }

    try {
      this.setGlobal({
        partnerPathway: [
          ...this.global.partnerPathway,
          { label: "Attendance", to: this.props.location.pathname }
        ]
      });
    } catch (globalError) {
      console.error('Error setting partnerPathway:', globalError);
    }
  }

  async changeDatePeriod(direction) {
    const type = this.props.location.search.split("?")[1];
    const start =
      direction === "next"
        ? startOfWeek(addDays(new Date(this.state.start), 7))
        : startOfWeek(subDays(new Date(this.state.start), 7));
    // this.dispatch.setWeeklySlotsPeriod(start);
    if (type === "Program") {
      const ep = `${process.env.REACT_APP_API}/partner/attendance/simple/${
        this.props.match.params.id
      }/${format(start, "yyyy-MM-dd")}/${format(
        endOfWeek(start),
        "yyyy-MM-dd"
      )}`;
      try {
        try {
          this.setGlobal({ loading: true });
        } catch (globalError) {
          console.error('Error setting loading state during date change:', globalError);
        }
        
        const res = await axios.get(ep);
        
        try {
          this.setState({
            students: res.data.data.students,
            attendance: res.data.data.attendance,
            start: start,
            end: endOfWeek(start)
          });
        } catch (stateError) {
          console.error('Error setting state during date change:', stateError);
        }
        
        try {
          this.setGlobal({ loading: false, lastAPICall: res });
        } catch (globalError) {
          console.error('Error updating global state during date change:', globalError);
        }
      } catch (ex) {
        console.error(ex);
        try {
          this.setGlobal({ loading: false, lastAPICall: null });
        } catch (globalError) {
          console.error('Error setting global state in catch during date change:', globalError);
        }
      }
    }
    if (type === "Online") {
      const ep = `${process.env.REACT_APP_API}/partner/attendance/online/${
        this.props.match.params.id
      }/${format(start, "yyyy-MM-dd")}/${format(
        endOfWeek(start),
        "yyyy-MM-dd"
      )}`;

      try {
        try {
          this.setGlobal({ loading: true });
        } catch (globalError) {
          console.error('Error setting loading state during online date change:', globalError);
        }
        
        const res = await axios.get(ep);

        try {
          this.setState({
            students: res.data.data.students,
            attendance: res.data.data.attendance,
            start: start,
            end: endOfWeek(start)
          });
        } catch (stateError) {
          console.error('Error setting state during online date change:', stateError);
        }
        
        try {
          this.setGlobal({ loading: false, lastAPICall: res });
        } catch (globalError) {
          console.error('Error updating global state during online date change:', globalError);
        }
      } catch (ex) {
        console.error(ex);
        try {
          this.setGlobal({ loading: false, lastAPICall: null });
        } catch (globalError) {
          console.error('Error setting global state in catch during online date change:', globalError);
        }
      }
    }
  }

  async setChildStatus(child) {
    const type = this.props.location.search.split("?")[1];

    if (type === "Program") {
      const attendance = {
        ...child.status,
        childId: child.child.student.childId,
        enrollmentId: child.child.student.enrollmentId,
        attDate: child.child.day,
        extendedHours: parseInt(child.status.extendedHours) || 0,
        extendedMinutes: parseInt(child.status.extendedMinutes) || 0,
        programId: this.state.programId,
        partnerId: this.global.organizationInfo.partnerId
      };
      const ep = `${process.env.REACT_APP_API}/partner/attendance`;
      try {
        try {
          this.setGlobal({ loading: true });
        } catch (globalError) {
          console.error('Error setting loading state:', globalError);
        }
        
        const res = await axios.post(ep, attendance);
        
        try {
          const ns = {
            attendance: {
              ...this.state.attendance,
              [child.child.student.enrollmentId]: {
                ...this.state.attendance[child.child.student.enrollmentId],
                [child.child.day]: res.data.data
              }
            }
          };
          this.setState(ns);
        } catch (stateError) {
          console.error('Error updating attendance state:', stateError);
        }
        
        try {
          this.setGlobal({ loading: false, lastAPICall: res });
        } catch (globalError) {
          console.error('Error updating global state:', globalError);
        }
      } catch (ex) {
        console.error(ex);
        if (ex.message === "Operation not completed") {
          console.log("Request was cancelled by axios interceptor - this is expected behavior");
          try {
            this.setGlobal({ loading: false });
          } catch (globalError) {
            console.error('Error setting loading state in catch block:', globalError);
          }
          return; 
        }
        try {
          this.setGlobal({ loading: false, lastAPICall: null });
        } catch (globalError) {
          console.error('Error setting global state in catch block:', globalError);
        }
      }
      // this.dispatch.setAttendanceChildStatus(child);*/
    }

    if (type === "Online") {
      const attendance = {
        ...child.status,
        childId: child.child.student.childId,
        onlineEnrollmentId: child.child.student.enrollmentId,
        attDate: child.child.day,
        extendedHours: parseInt(child.status.extendedHours) || 0,
        extendedMinutes: parseInt(child.status.extendedMinutes) || 0,
        onlineId: this.state.programId,
        partnerId: this.global.organizationInfo.partnerId
      };
      const ep = `${process.env.REACT_APP_API}/partner/attendance/online`;
      try {
        try {
          this.setGlobal({ loading: true });
        } catch (globalError) {
          console.error('Error setting loading state for online attendance:', globalError);
        }
        
        const res = await axios.post(ep, attendance);
        
        try {
          const ns = {
            attendance: {
              ...this.state.attendance,
              [child.child.student.enrollmentId]: {
                ...this.state.attendance[child.child.student.enrollmentId],
                [child.child.day]: res.data.data
              }
            }
          };
          this.setState(ns);
        } catch (stateError) {
          console.error('Error updating online attendance state:', stateError);
        }
        
        try {
          this.setGlobal({ loading: false, lastAPICall: res });
        } catch (globalError) {
          console.error('Error updating global state for online attendance:', globalError);
        }
      } catch (ex) {
        console.error(ex);
        if (ex.message === "Operation not completed") {
          console.log("Request was cancelled by axios interceptor - this is expected behavior");
          try {
            this.setGlobal({ loading: false });
          } catch (globalError) {
            console.error('Error setting loading state in catch block for online attendance:', globalError);
          }
          return; 
        }
        try {
          this.setGlobal({ loading: false, lastAPICall: null });
        } catch (globalError) {
          console.error('Error setting global state in catch block for online attendance:', globalError);
        }
      }
    }
  }

  render() {
    return (
      <div className="admin">
        <div className="container-fluid">
          <div className="cont">
            <h1>Attendance</h1>
          </div>
          <div className="cont">
            <div className="row">
              <div className="col-lg-12">
                <div className="data">
                  <p>
                    <button
                      style={{ background: "none", border: "none" }}
                      className="pl-3 pr-3 mr-2"
                      onClick={() => this.changeDatePeriod("prev")}
                    >
                      <img src={DataArrowLeft} alt="Previous" />
                    </button>
                    <span>
                      {format(this.state.start, "LLL d")} -&nbsp;
                      {format(this.state.end, "LLL d")},&nbsp;
                      {format(this.state.start, "yyyy")}
                    </span>
                    <button
                      style={{ background: "none", border: "none" }}
                      className="pl-3 pr-3 ml-2"
                      onClick={() => this.changeDatePeriod("next")}
                    >
                      <img src={DataArrowRight} alt="Next" />
                    </button>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <AttendanceCalendarTable
            setChildStatus={this.setChildStatus}
            students={this.state.students}
            attendance={this.state.attendance}
            start={this.state.start}
            end={this.state.end}
            program={this.state.program}
          />
        </div>
      </div>
    );
  }
}

export default Attendance;
